export default __webpack_public_path__ + "static/media/download.5c981afc.svg";